import { render } from "./todo-list.vue?vue&type=template&id=d5161952"
import script from "./todo-list.vue?vue&type=script&lang=js"
export * from "./todo-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__